// Post Object

// Packery

if ( $('.fig-post-object .content-feed').length ) {
  // console.log('running post object')
  var Packery = require('packery')

  var pckry = new Packery('.fig-post-object .content-feed', {
    // options...
    itemSelector: 'article',
    gutter: 0
  });
}



// WEBPACK FOOTER //
// ./wp-content/themes/figpress-child/src/js/modules/_post-object.js